import type { IdNameDto } from '../../Shared/Types/common';

export type AccountingExportCompanyLookup = IdNameDto;

interface AccountingExportCompanyLookupSource {
  id: number;
  name?: string | null;
}

export const mapCompanyToAccountingExportLookup = (
  company: AccountingExportCompanyLookupSource
): AccountingExportCompanyLookup | undefined => {
  const normalizedName = company.name?.trim();
  if (!normalizedName) {
    return undefined;
  }

  return {
    id: company.id,
    name: normalizedName,
  };
};
